import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { toast } from "sonner";
import api, { mediaUrl } from "@/lib/api";

export default function ImageUpload({ value, onChange, label = "Imagen", accept = "image/*" }) {
  const ref = useRef();
  const [uploading, setUploading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Archivo subido");
    } catch (err) { toast.error("Error al subir archivo"); }
    finally { setUploading(false); }
  };

  return (
    <div>
      <span className="block text-xs font-semibold uppercase tracking-wider text-sunset-muted mb-2">{label}</span>
      <div className="flex items-center gap-4">
        {value ? (
          <div className="relative w-24 h-24 bg-sunset-border overflow-hidden group flex items-center justify-center">
            {accept.includes("video") ? (
              <video src={mediaUrl(value)} className="w-full h-full object-cover" />
            ) : accept.includes("audio") ? (
              <div className="text-sunset-muted text-[10px] text-center px-1">🎵 Audio</div>
            ) : (
              <img src={mediaUrl(value)} alt="" className="w-full h-full object-cover" />
            )}
            <button type="button" onClick={() => onChange("")}
              className="absolute top-1 right-1 bg-black/60 text-white p-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <X size={14} />
            </button>
          </div>
        ) : (
          <button type="button" onClick={() => ref.current.click()} disabled={uploading}
            className="w-24 h-24 border-2 border-dashed border-sunset-border flex flex-col items-center justify-center text-sunset-muted hover:border-sunset-accent hover:text-sunset-accent transition-colors">
            <Upload size={18} />
            <span className="text-[10px] mt-1">{uploading ? "..." : "Subir"}</span>
          </button>
        )}
        <div className="flex-1">
          <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="o pega una URL"
            className="w-full bg-white border border-sunset-border px-3 py-2 text-sm focus:outline-none focus:border-sunset-accent" />
          <button type="button" onClick={() => ref.current.click()} disabled={uploading}
            className="text-xs text-sunset-accent mt-2 uppercase tracking-wider font-semibold">
            {uploading ? "Subiendo…" : "Subir archivo"}
          </button>
        </div>
      </div>
      <input ref={ref} type="file" accept={accept} onChange={handle} className="hidden" />
    </div>
  );
}
